module.exports = __webpack_public_path__ + "static/img/13.7bbc896.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/13.png
// module id = wPoa
// module chunks = 1